import { Namespace, NamespaceAPI } from '../../api/namespace'

const state = {
  all: [],
  current: 'default'
}

const getters = {}

const actions = {
  getAllNamespaces ({ commit, dispatch, state }: any) {
    NamespaceAPI.getAll(namespaces => {
      commit('setNamespaces', namespaces)

      if (state.current === undefined) {
        dispatch('selectCurrent', namespaces[0].metadata.name)
      }
    })
  },

  selectCurrent ({ commit, dispatch }: any, ns: string) {
    commit('selectCurrent', ns)
    dispatch('functions/getAllFunctions', ns, { root: true })
  }
}

const mutations = {
  setNamespaces (state: any, namespaces: Namespace[]) {
    state.all = namespaces
  },

  selectCurrent (state: any, ns: string) {
    state.current = ns
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
